import mainFirebase from 'firebase/compat/app';
import firebase from './index';
import 'firebase/compat/firestore';

const db = firebase.firestore();

export default db;
export const firestore = mainFirebase.firestore;
